import React from 'react';
import { motion } from 'framer-motion';
import sampleCertificate from '../assets/sample_certificate.png';
import sampleEndorsement from '../assets/sample_certificate.png';
import sampleInternship from '../assets/sample_certificate.png';
import sampleTraining from '../assets/sample_certificate.png';

const CertificationPage = () => {
  return (
    <div className="container py-5 my-5">
      {/* Header Section */}
      <motion.div
        className="text-center mb-3"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <h1 className="fw-bold text-dark  mx-auto">Certifications,Endorsement Letter & Paid InternShip offer letter</h1>
        <p className="lead text-muted">
          Empowering learners globally through real-world training, mentorship, and verified company-backed internships — powered by IIT alumni.
        </p>
      </motion.div>

      {/* Course Information Section */}
      <div className="row align-items-center mb-3 mx-auto">
        <div className="col-lg-5 mb-3 mb-lg-0 mx-auto">
          <h3 className="fw-semibold">Courses Offered with Certification</h3>
          <ul className="list-group list-group-flush">
            <li className="list-group-item">AI & Machine Learning (with Industry Projects)</li>
            <li className="list-group-item">Data Science and Business Analytics</li>
            <li className="list-group-item">Quantum Computing and Space Technology</li>
            <li className="list-group-item">Full Stack Web & App Development</li>
            <li className="list-group-item">Blockchain and Cybersecurity</li>
            <li className="list-group-item">Energy GeoSciences and Smart Technology</li>
            <li className="list-group-item">Future on Demand High Paying Courses ....</li>
          </ul>
        </div>
        <div className="col-lg-3 mx-auto ">
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            <img
              src={sampleTraining}
              alt="Training Session"
              className="img-fluid rounded shadow"
            />
          </motion.div>
           <div className="card-body py-2">
              <h5 className="card-title fw-bold text-center text-primary text-decoration-underline">Official Course Certificate</h5>
              <p className="card-text text-muted">Awarded to top-performing students completing academic and practical evaluations.</p>
            
            </div>
        </div>
        
      </div>

      {/* Certification Section */}
      <motion.div
        className="text-center mb-5"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <h2 className="fw-bold text-secondary mb-3">Our Official Certification Components</h2>
        <p className="text-muted">
          All participants completing their training under Olewin Academy IIT Alumni-led programs receive globally recognized certifications and letters — verifiable through our digital system.
        </p>
      </motion.div>

      {/* Certificates Section */}
      <div className="row g-4 text-center col-lg mx-auto ">
     

        <div className="col-md-6 col-lg-4">
          <motion.div whileHover={{ scale: 1.05 }} className="card shadow-sm border-0">
            <img src={sampleEndorsement} className="card-img-top" alt="Endorsement Letter" />
            <div className="card-body">
              <h5 className="card-title fw-semibold">Endorsement Letter</h5>
              <p className="card-text text-muted">Endorsed by our IIT Alumni panel and collaborating industry mentors.</p>
            </div>
          </motion.div>
        </div>

        <div className="col-md-6 col-lg-4">
          <motion.div whileHover={{ scale: 1.05 }} className="card shadow-sm border-0">
            <img src={sampleInternship} className="card-img-top" alt="Internship Letter" />
            <div className="card-body">
              <h5 className="card-title fw-semibold">Paid Internship Offer Letter</h5>
              <p className="card-text text-muted">Issued to eligible students selected for company projects with stipend support.</p>
            </div>
          </motion.div>
        </div>

        <div className="col-md-6 col-lg-4">
          <motion.div whileHover={{ scale: 1.05 }} className="card shadow-sm border-0">
            <img src={sampleTraining} className="card-img-top" alt="Training Certificate" />
            <div className="card-body">
              <h5 className="card-title fw-semibold">Real-Time Training Certificate</h5>
              <p className="card-text text-muted">Validated after successful completion of live, company-supervised projects.</p>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Footer Section */}
      <div className="text-center mt-5">
        <p className="text-muted small">
          © {new Date().getFullYear()} Olewin Academy — An IIT Alumni Initiative for Global Learning Excellence.
        </p>
      </div>
    </div>
  );
};

export default CertificationPage;
